/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 3.99951C8.91223 2.78534 10.3644 2 12 2C14.7614 2 17 4.23858 17 7V11C17 11.3425 16.9656 11.6769 16.9 12M18.8792 15.0002C19.5718 13.8733 20 12.5303 20 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 19C8.57143 19 4 16 4 11M12 19V22M12 19C13.6344 19 15.5284 18.3183 17.0632 17.0632M7 7V11C7 13.7614 9.23858 16 12 16C13.1257 16 14.1645 15.628 15.0002 15.0002M3 3L15.0002 15.0002M21 21L17.0632 17.0632M15.0002 15.0002L17.0632 17.0632"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M7 7V11C7 13.7614 9.23858 16 12 16C13.1257 16 14.1645 15.628 15.0002 15.0002L7 7Z"
				fill="currentColor"
			/>
			<path
				d="M12 19C8.57143 19 4 16 4 11M12 19V22M12 19C13.6344 19 15.5284 18.3183 17.0632 17.0632M20 11C20 12.5303 19.5718 13.8733 18.8792 15.0002M7 7V11C7 13.7614 9.23858 16 12 16C13.1257 16 14.1645 15.628 15.0002 15.0002M3 3L15.0002 15.0002M21 21L17.0632 17.0632M15.0002 15.0002L17.0632 17.0632M8 3.99951C8.91223 2.78534 10.3644 2 12 2C14.7614 2 17 4.23858 17 7V11C17 11.3425 16.9656 11.6769 16.9 12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C10.1186 1.25 8.44817 2.1544 7.40038 3.54901C7.17604 3.8476 7.20558 4.26575 7.46967 4.52984L15.9702 13.0303C16.1211 13.1812 16.3291 13.2607 16.5422 13.2488C16.7553 13.237 16.9532 13.1349 17.0864 12.9682C17.3192 12.6769 17.4985 12.3849 17.6105 12.0411C17.7208 11.7025 17.75 11.362 17.75 11V7C17.75 3.82436 15.1756 1.25 12 1.25ZM3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L6.25 7.31066V11C6.25 14.1756 8.82436 16.75 12 16.75C13.0582 16.75 14.051 16.4635 14.9034 15.9641L15.9163 16.9769C14.6486 17.813 13.2218 18.25 12 18.25C10.4846 18.25 8.65637 17.5778 7.20816 16.3106C5.77436 15.056 4.75 13.2524 4.75 11C4.75 10.5858 4.41421 10.25 4 10.25C3.58579 10.25 3.25 10.5858 3.25 11C3.25 13.7476 4.51136 15.944 6.22041 17.4394C7.69694 18.7314 9.53571 19.5261 11.25 19.7092V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V19.7092C14.1732 19.5572 15.681 18.9837 16.9955 18.0561L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L17.5935 16.5329L15.5305 14.4699L7.53075 6.47009L7.52991 6.46925L3.53033 2.46967ZM7.75 11V8.81066L13.7936 14.8543C13.249 15.1083 12.6415 15.25 12 15.25C9.65279 15.25 7.75 13.3472 7.75 11ZM20.75 11C20.75 10.5858 20.4142 10.25 20 10.25C19.5858 10.25 19.25 10.5858 19.25 11C19.25 12.3848 18.8639 13.5927 18.2402 14.6075C18.0233 14.9604 18.1336 15.4223 18.4865 15.6392C18.8393 15.8561 19.3012 15.7458 19.5181 15.3929C20.2797 14.1538 20.75 12.6758 20.75 11Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M4 11C4 14.6108 6.384 17.1785 9 18.3266M20 11C20 12.5303 19.5718 13.8733 18.8792 15.0002M12 22V21.5V20.6C12 20.0461 12 19.7691 12.0793 19.582C12.1617 19.3876 12.2367 19.2926 12.4067 19.1673C12.5702 19.0468 12.9083 18.9661 13.5844 18.8048C14.7796 18.5196 16.0066 17.9273 17.0632 17.0632M7 7V11C7 13.7614 9.23858 16 12 16C13.1257 16 14.1645 15.628 15.0002 15.0002M3 3L15.0002 15.0002M21 21L17.0632 17.0632M15.0002 15.0002L17.0632 17.0632M8 3.99951C8.91223 2.78534 10.3644 2 12 2C12.7111 2 13.3875 2.14845 14 2.41604M16.9 12C16.9656 11.6769 17 11.3425 17 11V7C17 6.2889 16.8516 5.61246 16.584 5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 19C8.57143 19 4 16 4 11M12 19V22M12 19C13.6344 19 15.5284 18.3183 17.0632 17.0632M20 11C20 12.5303 19.5718 13.8733 18.8792 15.0002M7 7V11C7 13.7614 9.23858 16 12 16C13.1257 16 14.1645 15.628 15.0002 15.0002M3 3L15.0002 15.0002M21 21L17.0632 17.0632M15.0002 15.0002L17.0632 17.0632M8 3.99951C8.91223 2.78534 10.3644 2 12 2C14.7614 2 17 4.23858 17 7V11C17 11.3425 16.9656 11.6769 16.9 12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C10.1186 1.25 8.44818 2.1544 7.40039 3.54901C7.17605 3.8476 7.20559 4.26575 7.46968 4.52984L15.9702 13.0303C16.1211 13.1812 16.3291 13.2607 16.5422 13.2488C16.7553 13.237 16.9532 13.1349 17.0864 12.9682C17.3192 12.6769 17.4985 12.3849 17.6105 12.0411C17.7209 11.7025 17.75 11.362 17.75 11V7C17.75 3.82436 15.1756 1.25 12 1.25ZM20.7502 11C20.7502 10.5858 20.4145 10.25 20.0002 10.25C19.586 10.25 19.2502 10.5858 19.2502 11C19.2502 12.3848 18.8641 13.5927 18.2404 14.6075C18.0235 14.9604 18.1338 15.4223 18.4867 15.6392C18.8396 15.8561 19.3015 15.7458 19.5184 15.3929C20.2799 14.1538 20.7502 12.6758 20.7502 11Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L6.25 7.31066V11C6.25 14.1756 8.82436 16.75 12 16.75C13.0582 16.75 14.051 16.4635 14.9034 15.9641L15.9163 16.9769C14.6486 17.813 13.2218 18.25 12 18.25C10.4846 18.25 8.65637 17.5778 7.20816 16.3106C5.77436 15.056 4.75 13.2524 4.75 11C4.75 10.5858 4.41421 10.25 4 10.25C3.58579 10.25 3.25 10.5858 3.25 11C3.25 13.7476 4.51136 15.944 6.22041 17.4394C7.69694 18.7314 9.53571 19.5261 11.25 19.7092V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V19.7092C14.1732 19.5572 15.681 18.9837 16.9955 18.0561L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L17.5935 16.5329L15.5305 14.4699L7.53077 6.47011L7.52989 6.46924L3.53033 2.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
